const SVGComponent = (props) => (
  <svg
    width={32}
    height={20}
    viewBox="0 0 32 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 6C0 2.68629 2.68629 0 6 0H26C29.3137 0 32 2.68629 32 6V14C32 17.3137 29.3137 20 26 20H6C2.68629 20 0 17.3137 0 14V6Z"
      fill="#1434CB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.63309 13.9379H7.49472L5.8912 7.73171C5.81509 7.44622 5.65349 7.19384 5.41578 7.07489C4.82254 6.77596 4.16883 6.53805 3.45569 6.41807V6.17913H6.90044C7.37586 6.17913 7.73243 6.53805 7.79186 6.9549L8.62385 11.4316L10.7612 6.17913H12.8401L9.63309 13.9379ZM14.0288 13.9379H12.0093L13.6722 6.17913H15.6917L14.0288 13.9379ZM18.3042 8.32835C18.3636 7.91047 18.7202 7.67153 19.1362 7.67153C19.7899 7.61154 20.502 7.73152 21.0963 8.02942L21.4528 6.35892C20.8586 6.11999 20.2049 6 19.6116 6C17.6515 6 16.2253 7.0747 16.2253 8.56625C16.2253 9.70095 17.2355 10.2967 17.9487 10.6557C18.7202 11.0136 19.0173 11.2525 18.9579 11.6104C18.9579 12.1472 18.3636 12.3862 17.7704 12.3862C17.0572 12.3862 16.3441 12.2072 15.6914 11.9083L15.3349 13.5798C16.048 13.8777 16.8195 13.9977 17.5327 13.9977C19.7305 14.0566 21.0963 12.983 21.0963 11.3714C21.0963 9.34202 18.3042 9.22307 18.3042 8.32835ZM28.1644 13.9379L26.5609 6.17913H24.8385C24.4819 6.17913 24.1253 6.41807 24.0065 6.77596L21.0372 13.9379H23.1161L23.5311 12.8042H26.0854L26.3231 13.9379H28.1644ZM25.1356 8.26842L25.7288 11.1926H24.0659L25.1356 8.26842Z"
      fill="white"
    />
  </svg>
);
export default SVGComponent;